if (!customElements.get('scrolling-content')) {
class ScrollingContent extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const template = document.createElement('template');
        template.innerHTML = `
            <slot name="images"></slot>
            <slot name="contents"></slot>
        `;
        this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    connectedCallback() {
        this.contentBlocks = this.querySelectorAll('.scrolling-content__content-block') || [];
        this.images = this.querySelectorAll('.scrolling-content__image-item') || [];
    
        if (this.images.length === 0 || this.contentBlocks.length === 0) {
            console.warn('No content blocks or images found');
            return;
        }

        if (this.images.length > 0) {
            this.images[0].classList.add('visible');
        }
        if (this.contentBlocks.length > 0) {
            this.contentBlocks[0].classList.add('active');
        }

        const observerOptions = {
    root: null,
    rootMargin: '-48% 0% -48% 0%',
    threshold: 0
};

this.observer = new IntersectionObserver(
    this.handleIntersect.bind(this),
    observerOptions
);

this.observerTriggers = [];

this.contentBlocks.forEach(block => {
    if (block.hasAttribute('data-index')) {
        const trigger = document.createElement('span');

        trigger.setAttribute(
            'data-index',
            block.getAttribute('data-index')
        );

        trigger.style.position = 'absolute';
        trigger.style.top = '50%';
        trigger.style.left = '0';
        trigger.style.width = '1px';
        trigger.style.height = '1px';
        trigger.style.pointerEvents = 'none';

        block.appendChild(trigger);

        this.observerTriggers.push(trigger);
        this.observer.observe(trigger);
    }
});
    }

    handleIntersect(entries) {
    entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const index = entry.target.getAttribute('data-index');

        const correspondingBlock = this.querySelector(
            `.scrolling-content__content-block[data-index="${index}"]`
        );

        const correspondingImage = this.querySelector(
            `.scrolling-content__image-item[data-index="${index}"]`
        );

        this.contentBlocks.forEach(block => {
            block.classList.remove('active');
        });

        if (correspondingBlock) {
            correspondingBlock.classList.add('active');
        }

        this.images.forEach(image => {
            image.classList.remove('visible');
        });

        if (correspondingImage) {
            correspondingImage.classList.add('visible');
        }
    });
}

    disconnectedCallback() {
        if (this.observer) {
            if (this.observerTriggers) {
    this.observerTriggers.forEach(trigger => {
        this.observer.unobserve(trigger);
    });
}
            this.observer.disconnect(); 
        }
    }
}
customElements.define('scrolling-content', ScrollingContent);
}